export const theme = {
  primary: "#A5F1E9",
  secondary: "#C0DEFF",
  tertiary: "#222222",
  other: "#ffffff",
  headerBg: "#151d20",
  headerText: "#c6ccd5",
  logoColor: "#ff7228",
};
